import { useMemo } from "react";

/**
 * Get a memoized id based on the name
 *
 * @param name
 */
export function useId(name) {
  return useMemo(() => `id-${name}`, [name]);
}
